var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformanceColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "408.77px",
    height: "448.9px",
    viewBox: "0 0 408.77 448.9",
    style: {
      enableBackground: "new 0 0 408.77 448.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0C958F;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:0.8;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#3376B7;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#F0D784;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#F63137;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:#F63137;stroke:#F63137;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#F63137;stroke-width:9;stroke-miterlimit:10;}\r\n\t.st12{fill:#F63137;stroke:#FFFFFF;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#0C958F;stroke-width:13;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#3376B7;stroke-width:13;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.03,243.03 106.13,243.69 106.13,222.9 85.1,214.35 67.77,228.65 34.1,194.38 48.42,180.24  40.55,160.6 19.1,159.7 16.17,112.28 40.29,111.54 47.66,90.84 32.5,72.84 66.01,40.46 84.35,54.84 103.7,48.02 103.78,26  151.52,25.26 154.29,47.61 174.64,56.24 189.47,42.93 214.26,61.66  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 133.52,
    y1: 280.99,
    x2: 119.36,
    y2: 294.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 338.3,
    y1: 280.67,
    x2: 351.79,
    y2: 294.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 337.97,
    y1: 81.39,
    x2: 352.12,
    y2: 68.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 235.37,
    y1: 39.23,
    x2: 235.78,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M216.35,304.33c0,0,13.74-78.23-6.87-109.95c0,0,22.11,35.67,51.68,0.66c0,0-17.09,76.84-6.45,109.3 L216.35,304.33L216.35,304.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M237.29,125.84c0,0,30.49-3.86,47.66,26.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 213.25,
    y1: 335.64,
    x2: 256.72,
    y2: 335.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 184.61,
    y1: 304.33,
    x2: 286.04,
    y2: 305.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M119.36,182.87c0,0-22.87-9.2-35.76-21.37c-3.18-3.04-7.62-11.92-8.71-15.37 c-4.44-14.3-2.35-31.97,6.53-44.05c3.1-4.19,6.28-8.71,13.74-13.64c3.69-2.47,11.89-5.92,18.09-7.15 c6.2-1.23,10.47-1.81,13.15-1.81c4.94,0,11.56,3.04,16.92,5.18c10.47,4.19,18.76,9.86,18.76,9.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M185.36,261.93c0,0-1.26,40.02-0.75,59.99c0.34,15.29,2.01,32.46,13.99,42.24 c9.63,7.89,23.28,8.55,35.85,8.79c9.72,0.16,19.93,0.16,28.39-4.52c14.91-8.14,19.1-26.95,20.86-43.55 c2.01-19.56-0.42-42.07-1.09-61.72c0,0,13.15-8.14,24.12-18.74c8.63-8.38,15.16-18.41,17.42-25.72 c2.43-8.22,7.12-19.64,8.38-31.23c1.34-11.59-0.75-23.42-2.43-32.54c-1.01-5.42-2.85-11.92-6.7-18.49 c-4.36-7.4-9.3-16.68-16.08-23.5c-5.53-5.59-10.8-10.68-17-14.63c-8.12-5.18-17.09-8.79-23.2-11.59 c-6.53-2.96-16.75-5.18-28.06-5.34c-16.67-0.16-34.59,4.11-43.97,8.38c-8.12,3.7-17.84,9.53-26.3,17.09 c-12.4,11.09-20.77,25.8-25.21,36.57c-2.85,6.74-5.7,18.08-6.53,29.5c-0.67,9.45,1.59,18.9,2.6,27.53 c1.09,9.12,5.95,18.33,8.54,22.85c3.18,5.51,8.79,14.71,15.08,21.12C173.72,255.03,185.36,261.93,185.36,261.93z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceColor);
export default __webpack_public_path__ + "static/media/performanceColor.96c2461fc0d5e5b8cfb7b79d29fdf97d.svg";
export { ForwardRef as ReactComponent };